import {Lists} from 'types'

const tables: Lists = {
    loaded: false,
    title: 'Order Book',
    headers: {
        title: 'price',
        title1: 'total',
        title2: 'amount',
    },
    url: 'wss://stream.binance.us:9443/ws',
    lists: {
        PIVX: {
            title: 'PIVX',
            inc: [0.0000001, 0.0001, 0.0002],
            ticker: 0.0000001,
            pair: 'PIVXBTC',
            prices: {
                bids: {
                    sortBy: 'DESC',
                    title: 'bids',
                    values: [
                        {
                            depth: 20,
                            cells: {
                                price: 1000,
                                amount: 100,
                                total: 100
                            }
                        },
                        {
                            depth: 20,
                            cells: {
                                price: 1000,
                                amount: 1001,
                                total: 1101
                            }
                        }
                    ],
                },
                asks: {
                    sortBy: 'ASC',
                    title: 'asks',
                    values: [
                        {
                            depth: 20,
                            cells: {
                                price: 1000,
                                amount: 100,
                                total: 100
                            }
                        },
                        {
                            depth: 20,
                            cells: {
                                price: 1000,
                                amount: 1001,
                                total: 1101
                            }
                        }
                    ],
                },
            },
        },
        BTC: {
            title: 'BTC',
            inc: [0.05, 0.1, 0.25],
            ticker: 0.05,
            pair: 'BTCUSDT',
            prices: {
                bids: {
                    sortBy: 'DESC',
                    title: 'bids',
                    values: [
                        {
                            depth: 20,
                            cells: {
                                price: 1000,
                                amount: 100,
                                total: 100
                            }
                        },
                        {
                            depth: 20,
                            cells: {
                                price: 1000,
                                amount: 1001,
                                total: 1101
                            }
                        }
                    ],
                },
                asks: {
                    sortBy: 'ASC',
                    title: 'asks',
                    values: [
                        {
                            depth: 20,
                            cells: {
                                price: 1000,
                                amount: 100,
                                total: 100
                            }
                        },
                        {
                            depth: 20,
                            cells: {
                                price: 1000,
                                amount: 1001,
                                total: 1101
                            }
                        }
                    ],
                },
            },
        },
        ETH: {
            title: 'ETH',
            inc: [0.05, 0.1, 0.25],
            ticker: 0.05,
            pair: 'ETHUSDT',
            prices: {
                bids: {
                    sortBy: 'DESC',
                    title: 'bids',
                    values: [
                        {
                            depth: 20,
                            cells: {
                                price: 1000,
                                amount: 100,
                                total: 100
                            }
                        },
                        {
                            depth: 20,
                            cells: {
                                price: 1000,
                                amount: 1001,
                                total: 1101
                            }
                        }
                    ],
                },
                asks: {
                    sortBy: 'ASC',
                    title: 'asks',
                    values: [
                        {
                            depth: 20,
                            cells: {
                                price: 1000,
                                amount: 100,
                                total: 100
                            }
                        },
                        {
                            depth: 20,
                            cells: {
                                price: 1000,
                                amount: 1001,
                                total: 1101
                            }
                        }
                    ],
                },
            },
        },
    },
}

export default tables
